import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "backdrop", "closeButton", "menuContainer"]

  connect() {
  }

  disconnect() {
  }

  toggle(event) {
    event.preventDefault()

    this.closeButtonTarget.classList.toggle("hidden")

    this.menuTarget.classList.toggle("translate-x-0")
    this.menuTarget.classList.toggle("-translate-x-full")
    this.backdropTarget.classList.toggle("opacity-100")
    this.backdropTarget.classList.toggle("opacity-0")

    this.menuContainerTarget.classList.toggle("pointer-events-auto")
    this.menuContainerTarget.classList.toggle("pointer-events-none")
  }

  isOpen() {
    return this.menuTarget.classList.contains("translate-x-0")
  }
} 